import { Button, Checkbox } from '@evertrue/et-components';
import { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'base/react-libs';
import { trackJourneysAction } from 'apps/journeys/utils/helpers/mixpanel';
import { useJourneyDetailProvider } from 'apps/journeys/context/journey-detail-context';
import TaskStatusMessage from './task-status-message';
import CompleteTaskToggle from 'apps/tasks/components/complete-task-toggle';
import JourneyContactCard from 'apps/journeys/components/journey-contact-card';
import TaskRowActionButton from './task-row-action-button';
import TaskRowOutreachButtons from './task-row-outreach-buttons';

const TaskRow = ({ task = {}, step = {}, handleCompletionClick = () => {} }) => {
  const scrollYRef = useRef(0);
  const focusedElementRef = useRef(null);

  const [isActive, setIsActive] = useState(false);
  const {
    journey = {},
    sidebarIsOpen,
    selectedTasks = [],
    setSelectedTasks = () => {},
    openContactSummary,
    inBulkSelectMode,
    optionalStateManagementFunction,
  } = useJourneyDetailProvider();

  useEffect(() => {
    if (!sidebarIsOpen) {
      setIsActive(false);
    }
  }, [sidebarIsOpen]);

  if (!task) return null;
  const { id, contact, action_type } = task || {};

  // Save scroll and focus before opening a drawer
  const handleDrawerOpen = () => {
    const container = document.getElementById('layout-page');
    scrollYRef.current = container ? container.scrollTop : window.scrollY;
    focusedElementRef.current = document.activeElement;
  };

  // Restore scroll and focus after closing a drawer
  const handleDrawerClose = () => {
    setTimeout(() => {
      if (focusedElementRef.current && typeof focusedElementRef.current.focus === 'function') {
        focusedElementRef.current.focus({ preventScroll: true });
      }
      const container = document.getElementById('layout-page');
      if (container) container.scrollTop = scrollYRef.current;
    }, 0);
  };

  return (
    <div key={`task-record-${id}`} className={`journeys-task-table-row--details ${isActive ? 'active' : ''}`}>
      <div>
        {inBulkSelectMode ? (
          <Checkbox
            label="Task Selector"
            checked={selectedTasks.some((t) => t.id === task.id)}
            onChange={(checked) => {
              if (checked) {
                setSelectedTasks((prev) => [...prev, task]);
              } else {
                setSelectedTasks((prev) => prev.filter((t) => t.id !== task.id));
              }
            }}
            className="checkbox-small"
            checkboxStyle={{ height: '18px', width: '18px', margin: '8px' }}
          />
        ) : (
          <CompleteTaskToggle
            step={step}
            task={task}
            size="small"
            onClick={handleCompletionClick}
            journey={journey}
            optionalStateManagementFunction={optionalStateManagementFunction}
          />
        )}
        <JourneyContactCard contact={contact || {}} currentJourney={journey} actionType={action_type} />
      </div>
      <div style={{ display: 'flex', gap: '15px' }}>
        <TaskStatusMessage task={task} />
        <TaskRowOutreachButtons task={task} onDrawerOpen={handleDrawerOpen} onDrawerClose={handleDrawerClose} />
        <TaskRowActionButton
          task={task}
          step={step}
          journey={journey}
          onDrawerOpen={handleDrawerOpen}
          onDrawerClose={handleDrawerClose}
        />
        <Button
          disabled={!task || !contact}
          onClick={() => {
            trackJourneysAction('view_link');
            openContactSummary(contact || {});
            setIsActive(true);
          }}
          type="simple"
        >
          Preview
        </Button>
      </div>
    </div>
  );
};

TaskRow.propTypes = {
  step: PropTypes.object.isRequired,
  task: PropTypes.object.isRequired,
  handleCompletionClick: PropTypes.func,
};

export default TaskRow;
